 $(document).ready(function(){
  $('.gridSlider').slick({
      dots: false,
      arrows: true,
      swipe: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
   });

      $('.subPeriods span:first-child').addClass('active');
      var firstAva = $('.subPeriods span:first-child').text();
      $('.subtype, .buttonAfter_text span').text(firstAva)
      $(document).on('click','.subPeriods span',function(){
          $('.subPeriods span').removeClass('active');
          $(this).addClass('active');
          var activeProp = $(this).text();
          $('#subscribe-period').val(activeProp);
          setTimeout( function(){
            $('.subtype, .buttonAfter_text span').text(activeProp)
          }, 300); 
      });
      
    $(document).on("click",".toggleswitch",function(){
      var e=$(this).attr("data-mode");
      if(e=="yes"){
        $(this).removeClass("toggleOn").addClass("toggleOff").attr("data-mode","no");
        $('#is_gift').val('no');
      }
      else{
        $(this).removeClass("toggleOff").addClass("toggleOn").attr("data-mode","yes");
        $('#is_gift').val('Yes');
      }
    });
   $(document).on("click",".variantOptions_grid2 label",function(e){
     $('.product-form__submit span').css("opacity","0");
    setTimeout( function(){
      $('.product-form__submit span').text('Checkout');
      $('.product-form__submit span').css("opacity","1");
     }, 1500); 
   });

});